export default __webpack_public_path__ + "static/media/channel-img.472f4267.png";